module.exports = __webpack_public_path__ + "static/media/iconBook.df7caa59.svg";